import ATMLoadProfileComponent from './atm_load_profile.component';
import ATMLoadProfileCreate from './create'
import ATMLoadProfileEdit from './edit'
import ATMLoadProfileAll from './all'

let ATMLoadProfileModule = angular.module('atmLoadProfile', [
  ATMLoadProfileCreate,
  ATMLoadProfileEdit,
  ATMLoadProfileAll
  ])

  .component('atmLoadProfile', ATMLoadProfileComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('atm_load_profile.edit', {
        url: '/edit/:id',
        component: 'atmLoadProfileEdit',
        data: {
          requireACL: 'tnt_control_atm_load_profile.edit'
        }
      })

      .state('atm_load_profile.create', {
        url: '/create',
        component: 'atmLoadProfileCreate',
        data: {
          requireACL: 'tnt_control_atm_load_profile.create'
        }
      })

      .state('atm_load_profile.all', {
        url: '/all/:page',
        component: 'atmLoadProfileAll',
        data: {
          requireACL: 'tnt_control_atm_load_profile.view'
        }        
      })
  })

  .name;

export default ATMLoadProfileModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/index.js